import { SollIstVersteuerungEnum } from '../v2024';

export const SollIstVersteuerungEnumLabels = {
    Sollversteuerung: 'Sollversteuerung' as SollIstVersteuerungEnum,
    Istversteuerung: 'Istversteuerung' as SollIstVersteuerungEnum
};

